import { QueryResolvers } from '@spazious/dollhouse-graphql';
import { normalize } from '@spazious/jsonapi-tools';

import { ApolloContext } from '../context.js';

/**
 * Resolver for the virtualSpace query.
 */
export const virtualSpace: QueryResolvers<ApolloContext>['virtualSpace'] = async (
  _,
  variables,
  context
) => {
  const { api } = context;
  const { id } = variables;

  const result = await api.diagramming.retrieveDiagrammingVirtualMeetingRoomId({
    id,
    include: 'meetingRoom.hotels',
  });
  const normalizedData = normalize(result.data as any) as any;
  const { attributes } = result.data.data;

  const meetingRoomName = normalizedData?.meetingRoom?.name;
  const meetingRoomHotels = normalizedData?.meetingRoom?.hotels ?? [];
  const hotelName = meetingRoomHotels.length === 1 ? meetingRoomHotels[0].name : '';

  return {
    id: attributes!.uuid!.toString(),
    model: attributes!.asset as any as string,
    placeholder: attributes!.assetPlaceholder as any as string,
    hotel: hotelName,
    name: meetingRoomName,
  };
};
